import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    marginBottom: 10,
    paddingVertical: 5,
    width: '100%',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0
  },
  contactDetails: {
    fontSize: 9,
    width: '84%',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    borderBottomRightRadius: 100,
    borderBottomLeftRadius: 100,
    backgroundColor: '#e4e4e4',
    paddingVertical: 6,
    paddingHorizontal: 10
  },
  itemContainer: {
    flexDirection: 'row'
  },
  iconsFooter: {
    width: 130,
    alignItems: 'center',
    justifyContent: 'center'
  },
  tenantImgContainer: {
    height: 30
  },
  img: {
    height: 30
  },
  emoji: {
    marginTop: 1,
    marginLeft: 3
  },
  adotelText: {
    marginTop: 8,
    fontSize: 10
  },
  adotelImgContainer: {
    marginTop: 7,
    height: 15,
    marginRight: 3
  },
  adotelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }
})
export default styles
